import {Spin} from "antd";
import React from "react";

interface IProps {
    height?: number;
}

const LargeSpinner : React.FC<IProps> = ({height}: IProps) => {
    return <div style={{height: height ? height+"px" : "400px", display:"block", width: "100%"}}>
        <Spin size={"large"} />
    </div>;
};
export default LargeSpinner;